import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ account, connectWallet, disconnectWallet }) => {
  return (
    <header className='header'>
      <div className='brand'>
        <Link to='/' className='brand-link'>Sbraint</Link>
      </div>
      <div className='nav-container'>
        <nav>
          <ul className='nav-links'>
            <li><Link to='/dashboard'>Dashboard</Link></li>
          </ul>
        </nav>
        <button onClick={account ? disconnectWallet : connectWallet} className="wallet-button">
          {account ? `${account.slice(0, 4)}...${account.slice(-4)}` : 'Connect Wallet'}
        </button>
      </div>
    </header>
  );
};

export default Header;
